import { Injectable } from '@angular/core';
import * as _ from 'lodash-es';

@Injectable()
export class NotificationService {
    notify_list: any = [];

    subscribe(name: string, msg: string, callback: any) {
        if (!this.findOne(name, msg)) {
            this.notify_list.push({
                name: name,
                msg: msg,
                callback: callback
            });
        }
    }

    unsubscribe(name: string, msg: string = '') {
        this.notify_list = _.filter(
            this.notify_list,
            function (item) {
                // If this item matches the params, remove it.
                if (name == item.name) {
                    if (!msg || (msg == item.msg)) {
                        return false;
                    }
                }
                return true;
            }
        )
    }

    findOne(name: string, msg: string = '') {
        return _.find(
            this.notify_list,
            { name: name, msg: msg }
        );
    }

    clear() {
        this.notify_list = [];
    }

    notifyAll(msg: string, data: any) {
        var targets = _.filter(
            this.notify_list,
            { msg: msg }
        );
        targets.forEach((dest) => {
            this.doNotify(dest, data);
        });
    }

    notifyOne(name: string, msg: string = '', data: any) {
        var target = this.findOne(name, msg);
        if (target) this.doNotify(target, data);
    }

    doNotify(target: any, data: any) {
        var callback = _.get(target, "callback", false);
        if (typeof callback === 'function') {
            try {
                callback(data);
            } catch (ex) {
                console.log("Callback failed for " + target.msg + ":" + target.name, ex);
            }
        }
    }
}